import Vue from 'vue'
import vSelect from 'vue-select'
import 'vue-select/src/scss/vue-select.scss'

Vue.component('VSelect', vSelect)
